<template>
  <Modal ref="newEmployeeModal" v-model="newEmployeeModal" class-name="newEmployeeStyle" :title="newEmployeeTitle" width="1000"
    :transfer="false" :mask-closable="false" @on-visible-change="newEmployeeModalChange" :loading="modalLoading">
    <div class="container_box details_box_styles">
      <!--基本资料-->
      <div class="basic_information_box">
        <Card dis-hover>
          <template #title><h2 class="title_box">{{ $t('key1005186') }}</h2></template>
          <Form ref="newEmployeeParams" :model="newEmployeeParams" :label-width="90" :rules="ruleCustom"
            label-position="right" @submit.native.prevent>
            <Row type="flex" :gutter="gutterItem">
              <Col :span="oneItemCol">
                <Form-item :label="$t('key1000068')" prop="email">
                  <Input v-model.trim="newEmployeeParams.email"></Input>
                </Form-item>
              </Col>
              <Col :span="oneItemCol">
                <Form-item :label="$t('key1001174')" prop="mobile">
                  <Input v-model.trim="newEmployeeParams.mobile"></Input>
                </Form-item>
              </Col>
              <Col :span="oneItemCol">
                <Form-item :label="$t('key1002676')" prop="userName">
                  <Input v-model.trim="newEmployeeParams.userName"></Input>
                </Form-item>
              </Col>
              <Col :span="oneItemCol" v-if="staffType !=='look'">
                <Form-item :label="$t('key1002791')" prop="password">
                  <div style="display: flex; align-items: center; justify-content: space-between;">
                    <Input style="width: 70%" v-model="newEmployeeParams.password" :element-id="'newEmployeeParams_password'"></Input>
                    <Button style="width: 25%" @click="getStrongPassword('newEmployeeParams', 'password')">{{ $t('key1002792') }}</Button>
                  </div>
                </Form-item>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
      <!--所属角色-->
      <div class="basic_information_box">
        <Card dis-hover>
          <template #title><h2 class="title_box">{{ $t('key1005187') }}</h2></template>
          <Checkbox-group class="roleList_box" v-model="newEmployeeParams.roleIdList">
            <div class="roleItem" v-for="(item, index) in changeRoleList" :key="index">
              <Checkbox :label="item.roleId" :title="item.title">
                <span class="page_role_item_title">{{ item.title }}</span>
              </Checkbox>
            </div>
          </Checkbox-group>
        </Card>
      </div>
      <!--仓库权限-->
      <div class="basic_information_box">
        <Card dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1005188') }}</h2>
          </template>
          <h2 class="font-size-13 mb12 color-333">{{ $t('key1005189') }}</h2>
          <Checkbox-group class="roleList_box" v-model="newEmployeeParams.ymsUserWarehouseOpers" @on-change="changeDataPermission">
            <div class="roleItem" v-for="(item, index) in warehouseList" :key="index">
              <Checkbox :label="item.ymsWarehouseId" :title="item.name" class="data_permission_content">
                <span class="page_role_item_title">{{ item.name }}</span>
                <div class="data_permission_box" v-if="newEmployeeParams.ymsUserWarehouseOpers.includes(item.ymsWarehouseId)">
                  <Checkbox :label="'dataPermission_'+ item.ymsWarehouseId">
                    <span class="page_role_item_title">{{ $t('key1005190') }}</span>
                  </Checkbox>
                </div>
              </Checkbox>
            </div>
          </Checkbox-group>
          <h2 class="font-size-13 mb12 mt12 title_bold">{{ $t('key1005191') }}</h2>
          <Checkbox v-model="newEmployeeParams.tokerUserALLOper" :true-value='1' :false-value='0'>
            <span class="page_role_item_title">{{ $t('key1005192') }}</span>
          </Checkbox>
        </Card>
      </div>
    </div>
    <template #footer>
      <Button @click="newEmployeeModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="newEmployeeBtn" v-if="(staffType === 'add' && getPermission('ymsCoreUserInfo_insert'))
      || (staffType === 'edit' && getPermission('ymsCoreUserInfo_update'))">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {getAllYmsWarehouseData} from "@/utils/common";

export default {
  name: "staffModal",
  mixins: [Mixin],
  props: {
    roleList: { // 角色的数据
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      staffType: 'add',
      modalLoading: false,
      oneItemCol: 12,
      newEmployeeTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005182'),
      newEmployeeModal: false,
      newEmployeeParams: {
        roleIdList: [],
        password: '',
        userName: '',
        email: '',
        mobile: '',
        ymsUserWarehouseOpers: [],
        tokerUserALLOper: 0, // 0 个人数据   1所有数据
      },
      ruleCustom: {
        password: [
          {required: true, validator: v.validatePass(), trigger: 'blur'}
        ],
        email: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005183'), trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000147'), trigger: 'blur'} // validator: v.validateMobile() 因为涉及海外手机号，暂时先放开手机号校验
        ],
        userName: [
          {required: true, validator: v.validateUserName(), trigger: 'blur'}
        ]
      },
      changeRoleList: [],
      warehouseList: [],
      ymsUserWarehouseOpers: [],
      dataPermissions: false,
    };
  },
  methods: {
    // 初始化数据
    initStaffData(type, userId) {
      let v = this;
      v.staffType = type;
      let titleObj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005173'),
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005184'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005185')
      };
      v.userId = userId || null;
      v.newEmployeeTitle = titleObj[type];
      // 所属角色数据
      v.changeRoleList = v.roleList.slice(1, v.roleList.length);
      // 仓库权限数据
      getAllYmsWarehouseData().then((data) => {
        v.warehouseList = data;
      });
      if (['look', 'edit'].includes(type)) {
        v.getUserInfo(userId);
      } else {
        v.newEmployeeModal = true;
      }
    },
    // 密码校验
    validatePass() {
      let v = this;
      return function (rule, value, callback) {
        if (v.newEmployeeParams.password === '' && v.uid === null) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001005')));
        } else {
          callback();
        }
      };
    },
    // 用户名校验，非空判断
    validateUserName() {
      let v = this;
      return function (rule, value, callback) {
        if (v.newEmployeeParams.userName === '') {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003147')));
        } else {
          callback();
        }
      };
    },
    // 获取员工的基本信息
    getUserInfo(userId) {
      let v = this;
      let newList = [];
      v.axios.post(api.post_ymsCoreUserInfo_id + userId, {}, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let keyList = ['roleIdList', 'userName', 'email', 'mobile', 'tokerUserALLOper'];
          for (let key in data) {
            if (keyList.includes(key)) {
              v.newEmployeeParams[key] = data[key];
            }
          }
          v.ymsUserWarehouseOpers = data.ymsUserWarehouseOpers || [];
          if (data.ymsUserWarehouseOpers && data.ymsUserWarehouseOpers.length > 0) {
            data.ymsUserWarehouseOpers.map((item) => {
              let obj = item.extendJson ? JSON.parse(item.extendJson) : '';
              if (obj && obj.otherUserOper.length > 0) {
                let value = 'dataPermission_' + item.ymsWarehouseId;
                newList.push(value);
              }
              newList.push(item.ymsWarehouseId);
            });
          }
          v.newEmployeeParams.ymsUserWarehouseOpers = v.uniqueFunc(newList);
          v.newEmployeeModal = true;
        }
      });
    },

    // 新增、编辑员工的保存按钮
    newEmployeeBtn() {
      let v = this;
      let url = '';
      let text = '';
      let method = '';
      let obj = JSON.parse(JSON.stringify(v.newEmployeeParams));
      obj.ymsUserWarehouseOpers = [];
      let ymsUserWarehouseOpers = [];
      let dataPermissionList = [];
      let newList = v.newEmployeeParams.ymsUserWarehouseOpers;
      if (newList.length > 0) {
        newList.map((value) => {
          if (value.indexOf('dataPermission_') > -1) {
            let ymsWarehouseId = value.split('dataPermission_')[1];
            dataPermissionList.push(ymsWarehouseId);
          } else {
            ymsUserWarehouseOpers.push({
              ymsWarehouseId: value,
              otherUserOper: []
            });
          }
        });
        if (dataPermissionList.length > 0) {
          ymsUserWarehouseOpers.map((item) => {
            if (dataPermissionList.includes(item.ymsWarehouseId)) {
              item.otherUserOper = ['all'];
            }
          });
        }
      }
      // 新增员工
      if (v.staffType === 'add') {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000776');
        method = 'POST';
        url = api.post_ymsCoreUserInfo;
        obj.ymsUserWarehouseOpers = ymsUserWarehouseOpers;
      }
      // 编辑员工
      else if (v.staffType === 'edit') {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001205');
        method = 'PUT';
        url = api.put_ymsCoreUserInfo;
        obj.userId = v.userId;
        if (obj.password === '') {
          delete obj.password;
        }
        if (!obj.mobile) {
          obj.mobile = '';
        }
        ymsUserWarehouseOpers.map((item) => {
          v.ymsUserWarehouseOpers.map((ele) => {
            if (item.ymsWarehouseId === ele.ymsWarehouseId) {
              let {otherUserOper, ...obj} = ele;
              for (let key in obj) {
                item[key] = ele[key];
              }
            }
          });
          obj.ymsUserWarehouseOpers.push(item);
        });
      }
      v.modalLoading = true;
      v.$refs['newEmployeeParams'].validate((valid) => {
        if (valid) {
          let query = {
            loading: true,
            loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247'),
            method: method,
            url: url,
            data: Object.assign({}, obj)
          };
          v.axios(query).then(response => {
            v.modalLoading = false;
            if (response.data.code === 0) {
              v.newEmployeeModal = false;
              v.$Message.success(text);
              v.$emit('saveSuccess');
            }
          });
        }
      });
    },
    // 选择
    changeDataPermission(valueList) {
      let v = this;
      if (valueList.length > 0) {
        valueList.map((value, index) => {
          if (value.indexOf('dataPermission_') > -1) {
            let ymsWarehouseId = value.split('dataPermission_')[1];
            if (!valueList.includes(ymsWarehouseId)) {
              valueList.splice(index, 1);
            }
          }
        });
      }
    },
    // 监听弹窗
    newEmployeeModalChange(value) {
      let v = this;
      if (!value) {
        v.newEmployeeParams.roleIdList = [];
        v.$refs['newEmployeeParams'].resetFields();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .newEmployeeStyle {
  .ivu-modal-body {
    max-height: 650px;
    overflow-y: auto;
  }

  .roleList_box {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    .roleItem {
      margin-bottom: 12px;
      width: 184px;

      .ivu-checkbox-group-item {
        display: flex;
        align-items: center;
      }

      .data_permission_content {
        display: flex;
        flex-wrap: wrap;
        align-items: initial;

        .data_permission_box {
          margin: 8px 0 15px 17px;
        }
      }
    }
  }

  .ivu-checkbox-wrapper {
    display: flex;

    .page_role_item_title {
      display: block;
      margin-left: 6px;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
      overflow: hidden;
    }
  }
}
</style>
